import { Survey, SurveyStatus } from "../../../redux/survey/survey.types";
import { formatDisplayDate } from "../../../helpers/date.helpers";
import { canEditSurvey } from "../../../redux/survey/survey.helpers";

const { Live, Complete, Rejected } = SurveyStatus;

const surveyCardSubtitle = (survey: Survey) => {
  const { surveyStatus, questionCount, completedUsers, aiCompletedUsers, maxCompletes, maxAICompletes, startDate, createdAt } = survey;
  let subtitleText = `${questionCount ?? 0} question`;
  if (questionCount !== 1) {
    subtitleText += 's';
  }

  if (canEditSurvey(surveyStatus)) {
    return subtitleText;
  }

  if (completedUsers !== null || aiCompletedUsers !== null) {
    const totalCompleted = (completedUsers ?? 0) + (aiCompletedUsers ?? 0);
    const totalMaxCompletes = (maxCompletes ?? 0) + (maxAICompletes ?? 0);
    subtitleText += ` · ${totalCompleted}${totalMaxCompletes ? '/' + totalMaxCompletes : ''}`;
  }

  subtitleText += ` · ${formatDisplayDate(startDate || createdAt)}`;

  return subtitleText;
};

const surveyStatusBgColor = (status: SurveyStatus) => {
  switch (status) {
    case Live:
      return 'bg-blue-500';
    case Complete:
      return 'bg-status-complete';
    case Rejected:
      return 'bg-status-rejected';
    default:
      return '';
  }
};

const surveyStatusTextColor = (status: SurveyStatus) => {
  switch (status) {
    case Live:
      return 'text-blue-500';
    case Complete:
      return 'text-status-complete';
    case Rejected:
      return 'text-status-rejected';
    default:
      return 'text-black';
  }
};


const fallbackImageBackgroundColor = (index: number) => {
  const colors = ['bg-green-1000', 'bg-purple-300', 'bg-orange-400', 'bg-human-orange-2'];
  const colorIndex = index % colors.length;
  return colors[colorIndex];
};

export { surveyCardSubtitle, surveyStatusBgColor, surveyStatusTextColor, fallbackImageBackgroundColor };
